var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", staticStyle: { height: "100%" } },
    [
      _c(
        "search-item",
        {
          key: _vm.identify,
          ref: _vm.identify,
          attrs: {
            "show-more-scheme": true,
            "show-simple": true,
            "expand-adv": true,
            "search-item-code": _vm.searchItemCode,
            "config-module": _vm.configModule,
            "auto-init": _vm.searchItemAutoInit,
            "custom-search-items": _vm.customSearchItems,
            "custom-sim-query-placeholder": _vm.simQueryPlaceholder
          },
          on: {
            "click-more": function(value) {
              return (_vm.isAdvancedQuery = value)
            },
            advSearchItemCallBack: _vm.toAdvancedQuery,
            simSearchItemCallBack: _vm.toSimpleQuery,
            advToggle: _vm.scrollCallback
          }
        },
        [
          _c("template", { slot: "operations" }, [_vm._t("operations")], 2),
          _c(
            "template",
            { slot: "searchAreaHeader" },
            [_vm._t("searchAreaHeader")],
            2
          ),
          _c("template", { slot: "other" }, [_vm._t("other")], 2)
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "config-module": _vm.gridConfigModule,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "grid-params": _vm.gridParams
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: _vm.onGridReady
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pagination-wrapper",
          attrs: { id: "footer-wrapper-tab-billpayment" }
        },
        [
          _c(
            "div",
            {
              class: "fixedBottom",
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "flex-wrap": "wrap"
              }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedDataList.length > 0,
                      expression: "selectedDataList.length > 0"
                    }
                  ]
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("Clearing.Selected") +
                          _vm.selectedDataList.length +
                          ":"
                      ) +
                      " "
                  )
                ]
              ),
              _vm.reCalc
                ? _c("charge-currency-total-group", {
                    key: 1,
                    attrs: {
                      type: _vm.totalType,
                      "arap-group": true,
                      "amount-to-currency": _vm.localCurrency,
                      "data-field": _vm.totalDataField,
                      "data-provider":
                        _vm.selectedDataList.length > 0
                          ? _vm.selectedDataList
                          : _vm.rowData,
                      "arap-order": "ar,ap",
                      source: "bankSlip",
                      "ar-field": _vm.arField
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("cargo-pagination", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              total: _vm.total,
              "page-count": _vm.pageCount,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQueryByPage
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }